const keyFullloopAccessToken = 'fullloop/access_token';
const keyFullloopRefreshToken = 'fullloop/refresh_token';
const keyComposerRefreshToken = 'fullloop/composer/token';
const keyComposerAccessToken = 'fullloop/composer/accessToken';
const keySurveyRefreshToken = 'fullloop/survey/token';
const keySurveyAccessToken = 'fullloop/survey/accessToken';
const keyCallCenterRefreshToken = 'fullloop/callcenter/token';
const keyCallCenterAccessToken = 'fullloop/callcenter/accessToken';
const keyReportRefreshToken = 'fullloop/report/token';
const keyReportAccessToken = 'fullloop/report/accessToken';

const get = (key: string) => {
  return () => localStorage.getItem(key);
};

const set = (key: string) => {
  return (value: string) => localStorage.setItem(key, value);
};

const del = (key: string) => {
  return () => localStorage.removeItem(key);
};

// standard token
export const getAccess = get(keyFullloopAccessToken);
export const setAccess = set(keyFullloopAccessToken);
export const delAccess = del(keyFullloopAccessToken);
export const getRefresh = get(keyFullloopRefreshToken);
export const setRefresh = set(keyFullloopRefreshToken);
export const delRefresh = del(keyFullloopRefreshToken);

// auth app token
export const getComposerAccess = get(keyComposerAccessToken);
export const setComposerAccess = set(keyComposerAccessToken);
export const delComposerAccess = del(keyComposerAccessToken);
export const getComposerRefresh = get(keyComposerRefreshToken);
export const setComposerRefresh = set(keyComposerRefreshToken);
export const delComposerRefresh = del(keyComposerRefreshToken);

export const getSurveyAccess = get(keySurveyAccessToken);
export const setSurveyAccess = set(keySurveyAccessToken);
export const delSurveyAccess = del(keySurveyAccessToken);
export const getSurveyRefresh = get(keySurveyRefreshToken);
export const setSurveyRefresh = set(keySurveyRefreshToken);
export const delSurveyRefresh = del(keySurveyRefreshToken);

export const getCallCenterAccess = get(keyCallCenterAccessToken);
export const setCallCenterAccess = set(keyCallCenterAccessToken);
export const delCallCenterAccess = del(keyCallCenterAccessToken);
export const getCallCenterRefresh = get(keyCallCenterRefreshToken);
export const setCallCenterRefresh = set(keyCallCenterRefreshToken);
export const delCallCenterRefresh = del(keyCallCenterRefreshToken);

export const getReportAccess = get(keyReportAccessToken);
export const setReportAccess = set(keyReportAccessToken);
export const delReportAccess = del(keyReportAccessToken);
export const getReportRefresh = get(keyReportRefreshToken);
export const setReportRefresh = set(keyReportRefreshToken);
export const delReportRefresh = del(keyReportRefreshToken);
